// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"StatusBadge_badgeWrapper__Ijx08","badgeIcon":"StatusBadge_badgeIcon__DvRD5"};